//------------------------23-05-2025----------
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const TicketPdf = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { bookingId, total_price, base_price,userId,companyName,fullName,phoneNumber } = location.state || {};

  const [ticketData, setTicketData] = useState(null);
  const [error, setError] = useState(null);

  const saveTicketToDB = async (ticketData, totalPrice, basePrice,userId,companyName,fullName,phoneNumber) => {
    if (!ticketData) {
      console.error("Cannot save null ticket data.");
      return;
    }

    const payload = {
      ...ticketData,
      userId:userId,
      total_price: totalPrice,
      base_price: basePrice,
      companyName:companyName,
      fullName:fullName,
      phoneNumber:phoneNumber
    };
    console.log("payload is...",payload);

    try {
      const response = await fetch("https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.bo7ki6/tic456det", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (response.ok) {
        console.log("Ticket saved successfully:", result);
      } else {
        console.error("Error saving ticket:", result);
      }
    } catch (err) {
      console.error("Error saving ticket:", err);
    }
  };

  useEffect(() => {
    const fetchTicketData = async () => {
      try {
        const storedToken = localStorage.getItem("b2bAuthToken");
        if (!storedToken) {
          setError("Authentication failed. Please log in again.");
          navigate("/login");
          return;
        }

        const { token, externalApiToken } = JSON.parse(storedToken);
        if (!token || !externalApiToken) {
          setError("Authentication failed. Please log in again.");
          navigate("/login");
          return;
        }

        const response = await fetch(
          `https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/i8h7g6f56/${bookingId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: ` ${token}`,
              "External-Authorization": `${externalApiToken}`,
            },
          }
        );

        const result = await response.json();
        if (response.ok && result.code === "200" && result.status === "success") {
          setTicketData(result.data);
          saveTicketToDB(result.data, total_price, base_price,userId,companyName,fullName,phoneNumber);
        } else {
          setError(result.message || "Failed to fetch ticket data.");
          console.error("Error fetching ticket data:", result);
        }
      } catch (err) {
        setError("An error occurred while fetching ticket data.");
        console.error("Error fetching ticket data:", err);
      }
    };

    if (bookingId) {
      fetchTicketData();
    } else {
      setError("Booking ID is missing.");
    }
  }, [bookingId, navigate, total_price, base_price,userId]);

  const downloadPDF = () => {
    const ticketElement = document.getElementById("ticket");
    html2canvas(ticketElement).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
      pdf.save("ticket.pdf");
    });
  };

  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!ticketData) return <p>Loading ticket details...</p>;

  return (
    <div>
      <div
        id="ticket"
        style={{
          backgroundColor: "white",
          width: "800px",
          margin: "20px auto",
          fontFamily: "Arial, sans-serif",
          fontSize: "12px",
          border: "1px solid #000",
        }}
      >
        {/* Booking Details */}
        <table style={{ width: "100%", borderCollapse: "collapse", borderBottom: "1px solid black" }}>
          <tbody>
            <tr>
              <td style={{ padding: "10px", borderRight: "1px solid black" }}>
                <strong>Airline PNR Number: {ticketData.pnr}</strong>
              </td>
              <td style={{ padding: "10px", borderRight: "1px solid black" }}>
                <strong>Booked on: {ticketData.booking_date}</strong>
              </td>
              <td style={{ padding: "10px" }}>
                <strong>Status: Confirmed</strong>
              </td>
              <td style={{ padding: "10px" }}>
                <strong>Booking ID: {ticketData.booking_id}</strong>
              </td>
            </tr>
          </tbody>
        </table>

        {/* Passenger Information */}
        {Object.entries(ticketData.passenger_details).map(([type, passengers]) => (
          <div key={type} style={{ padding: "10px", borderBottom: "1px solid black", color: "black" }}>
            <strong>{type}(s) Information</strong>
            {passengers.map((passenger, index) => (
              <p key={index} style={{ color: "black" }}>{passenger.Name}</p>
            ))}
          </div>
        ))}

        {/* Flight Details */}
        <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", borderBottom: "1px solid black" }}>
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2" }}>
              <th style={{ padding: "10px", border: "1px solid black" }}>TRAVEL DATE</th>
              <th style={{ padding: "10px", border: "1px solid black" }}>SECTOR</th>
              <th style={{ padding: "10px", border: "1px solid black" }}>DEP TIME</th>
              <th style={{ padding: "10px", border: "1px solid black" }}>ARR TIME</th>
              <th style={{ padding: "10px", border: "1px solid black" }}>FLIGHT NO.</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: "10px", border: "1px solid black" }}>{ticketData.departure_date}</td>
              <td style={{ padding: "10px", border: "1px solid black" }}>{ticketData.sector}</td>
              <td style={{ padding: "10px", border: "1px solid black" }}>{ticketData.departure_time}</td>
              <td style={{ padding: "10px", border: "1px solid black" }}>{ticketData.arrival_time}</td>
              <td style={{ padding: "10px", border: "1px solid black" }}>{ticketData.flight_no}</td>
            </tr>
          </tbody>
        </table>

        {/* Pricing Details 
        <div style={{ padding: "10px", borderBottom: "1px solid black", color: "black" }}>
          <strong>Pricing Information</strong>
          <p style={{ margin: 0 }}>Base Price: ₹{base_price || "N/A"}</p>
          <p style={{ margin: 0 }}>Total Price: ₹{total_price || ticketData.total_amount || "N/A"}</p>
        </div>*/}

        {/* Contact Information */}
        <div style={{ padding: "10px", borderBottom: "1px solid black" }}>
          <strong>Contact Information</strong>
          <p style={{ color: "black" }}>{ticketData.agency_name}</p>
        </div>
      </div>

      <button
        onClick={downloadPDF}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          cursor: "pointer",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
        }}
      >
        Download PDF
      </button>
    </div>
  );
};

export default TicketPdf;
